import TextField from '@material-ui/core/TextField'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'

import ConfirmationModal from '../ConfirmationModal'

import { toast } from 'react-toastify'

import { i18n } from '../../translate/i18n'


import { Grid } from '@material-ui/core'
import useTicketNotes from '../../hooks/useTicketNotes'

import { useStyles } from './style'

const NoteSchema = Yup.object().shape({
  note: Yup.string().min(2, 'Too Short!').required('Required')
})
export function ContactNotes({ ticket }) {
  const { id: ticketId, contactId } = ticket
  const classes = useStyles()
  const [newNote, setNewNote] = useState({ note: '' })
  const [, setLoading] = useState(false)
  const [showOnDeleteDialog, setShowOnDeleteDialog] = useState(false)
  const [selectedNote, setSelectedNote] = useState({})
  const [, setNotes] = useState([])
  const { saveNote, deleteNote, listNotes } = useTicketNotes()

  useEffect(() => {
    async function openAndFetchData() {
      handleResetState()
      await loadNotes()
    }
    openAndFetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleResetState = () => {
    setNewNote({ note: '' })
    setLoading(false)
  }

  const handleChangeComment = e => {
    setNewNote({ note: e.target.value })
  }

  const handleSave = async values => {
    setLoading(true)
    try {
      await saveNote({
        ...values,
        ticketId,
        contactId
      })
      await loadNotes()
      setNewNote({ note: '' })
      toast.success('Observação adicionada com sucesso!')
    } catch (e) {
      toast.error(e)
    }
    setLoading(false)
  }

  // const handleOpenDialogDelete = item => {
  //   setSelectedNote(item)
  //   setShowOnDeleteDialog(true)
  // }

  const handleDelete = async () => {
    setLoading(true)
    try {
      await deleteNote(selectedNote.id)
      await loadNotes()
      setSelectedNote({})
      toast.success('Observação excluída com sucesso!')
    } catch (e) {
      toast.error(e)
    }
    setLoading(false)
  }

  const loadNotes = async () => {
    setLoading(true)
    try {
      const notes = await listNotes({ ticketId, contactId })
      setNotes(notes)
    } catch (e) {
      toast.error(e)
    }
    setLoading(false)
  }

  // const renderNoteList = () => {
  //   return notes.map(note => {
  //     return (
  //       <ContactNotesDialogListItem
  //         note={note}
  //         key={note.id}
  //         deleteItem={handleOpenDialogDelete}
  //       />
  //     )
  //   })
  // }

  return (
    <>
      <ConfirmationModal
        title="Excluir Registro"
        open={showOnDeleteDialog}
        onClose={setShowOnDeleteDialog}
        onConfirm={handleDelete}
      >
        Deseja realmente excluir este registro?
      </ConfirmationModal>
      <Formik
        initialValues={newNote}
        enableReinitialize={true}
        validationSchema={NoteSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            handleSave(values)
            actions.setSubmitting(false)
          }, 400)
        }}
      >
        {({ touched, errors, setErrors }) => (
          <div>
            <Grid container spacing={2}>
              <Grid xs={12} item>
                <TextField
                  className={classes.textarea}
                  multiline
                  minRows={4}
                  maxRows={4}
                  name="note"
                  // label={i18n.t('ticketOptionsMenu.appointmentsModal.textarea')}
                  placeholder={i18n.t(
                    'ticketOptionsMenu.appointmentsModal.placeholder'
                  )}
                  error={touched.note && Boolean(errors.note)}
                  helperText={touched.note && errors.note}
                  variant="outlined"
                  onChange={handleChangeComment}
                  fullWidth
                  id="note"
                />
              </Grid>
              {/* {notes.length > 0 && (
                <Grid xs={12} item>
                  <List className={classes.list}>{renderNoteList()}</List>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                md={12}
                sm={6}
                className={classes.actionButton}
              >
              </Grid> */}
            </Grid>
          </div>
        )}
      </Formik>
    </>
  )
}
